import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  applyFilters,
  removeFilters,
  apidata,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  hubFilter,
  setHubFilter,
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="fromDate">
            <Form.Label>From Date</Form.Label>
            <Form.Control
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="toDate">
            <Form.Label>To Date</Form.Label>
            <Form.Control
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Form.Group>

          {/* <Form.Group controlId="hubFilter">
            <Form.Label>Hubs</Form.Label>
            <Form.Control
              as="select"
              value={hubFilter || ""}
              onChange={(e) => setHubFilter(e.target.value)}
            >
              <option value="">All Hubs</option>
              {apidata &&
                Array.from(
                  new Set(
                    apidata.flatMap((item) => {
                      if (
                        item.tripSummary &&
                        typeof item.tripSummary === "object"
                      ) {
                        return Object.values(item.tripSummary).map(
                          (summary) => summary.hub
                        );
                      }
                      return [];
                    })
                  )
                )
                  .filter(Boolean) // Ensure all names are valid
                  .map((hub, index) => (
                    <option key={index} value={hub}>
                      {hub}
                    </option>
                  ))}
            </Form.Control>
          </Form.Group> */}
          {/* <Form.Group controlId="hubFilter" className="mt-3">
            <Form.Label className="fw-semibold">Hubs</Form.Label>

            <Form.Control
              as="select"
              multiple
              value={hubFilter}
              onChange={(e) =>
                setHubFilter(
                  Array.from(e.target.selectedOptions, (option) => option.value)
                )
              }
              style={{ height: "140px" }} // visible multi-select box
            >
              {Array.from(
                new Set(
                  apidata?.flatMap((item) =>
                    Object.values(item.tripSummary || {}).map((s) => s.hub)
                  ) || []
                )
              )
                .filter(Boolean)
                .map((hub, index) => (
                  <option key={index} value={hub}>
                    {hub}
                  </option>
                ))}
            </Form.Control>
          </Form.Group> */}

          <Form.Group controlId="hubFilter" className="mt-3">
            <Form.Label className="fw-semibold">Hubs</Form.Label>

            <div
              className="border rounded p-2"
              style={{
                maxHeight: "150px",
                overflowY: "auto",
                background: "#fafafa",
              }}
            >
              {Array.from(
                new Set(
                  apidata?.flatMap((item) =>
                    item.tripSummary && typeof item.tripSummary === "object"
                      ? Object.values(item.tripSummary).map((s) => s.hub)
                      : []
                  )
                )
              )
                .filter(Boolean)
                .map((hub, index) => (
                  <Form.Check
                    key={index}
                    type="checkbox"
                    label={hub}
                    value={hub}
                    checked={hubFilter.includes(hub)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setHubFilter([...hubFilter, hub]);
                      } else {
                        setHubFilter(hubFilter.filter((h) => h !== hub));
                      }
                    }}
                    className="mb-1"
                  />
                ))}
            </div>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilters}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
